import { fieldTypes, TABS } from "@icarius-utils/constants";

const NAME = "CERTIFICATES_PAGE";

export const certificatesEmployeeFields = [
  {
    name: "CODIGO DE EMPLEADO",
    type: fieldTypes.text,
    label: "employeeCode",
    tab: TABS.personal,
  },
  {
    name: "PERSONAL DE PLANTA",
    type: fieldTypes.text,
    label: "plantPersonnel",
    tab: TABS.personal,
  },
  {
    name: "NRO INTERNO",
    type: fieldTypes.text,
    label: "internalNumber",
    tab: TABS.personal,
  },
  {
    name: "EMAIL",
    type: fieldTypes.email,
    label: "email",
    tab: TABS.personal,
  },  
  {
    name: "ESTADO CIVIL",
    type: fieldTypes.text,
    label: "civilState",
    tab: TABS.personal,
  },
  {
    name: "SEXO",
    type: fieldTypes.text,
    label: "sex",
    tab: TABS.personal,
  },
  {
    name: "NACIONALIDAD",
    type: fieldTypes.text,
    label: "nationality",
    tab: TABS.personal,
  },
  
  {
    name: "FECHA DE NACIMIENTO",
    type: fieldTypes.text,
    label: "bornDate",
    tab: TABS.personal,
  },
  {
    name: "CELULAR",
    type: fieldTypes.phone,
    label: "cellphone",
    tab: TABS.personal,
  },
  {
    name: "DIRECCION",
    type: fieldTypes.address,
    label: "address",
    tab: TABS.personal,
  },
  
  {
    name: "PAIS",
    type: fieldTypes.text,
    label: "country",
    tab: TABS.personal,
  },
  {
    name: "REGION",
    type: fieldTypes.text,
    label: "region",
    tab: TABS.personal,
  },
  {
    name: "PROVINCIA",
    type: fieldTypes.text,
    label: "provicia",
    tab: TABS.personal,
  },
  {
    name: "COMUNA",
    type: fieldTypes.text,
    label: "comuna",
    tab: TABS.personal,
  },
  {
    name: "CODIGO POSTAL",
    type: fieldTypes.text,
    label: "postalCode",
    tab: TABS.personal,
  },  
  {
    name: "TIPO DE FUNCIONARIO",
    type: fieldTypes.text,
    label: "fType",
    tab: TABS.contract,
  },
  {
    name: "CARGO",
    type: fieldTypes.text,
    label: "position",
    tab: TABS.contract,
  },
  {
    name: "FECHA ASIGNACION CARGO",
    type: fieldTypes.text,
    label: "positionDate",
    tab: TABS.contract,
  },
  {
    name: "FUNCION",
    type: fieldTypes.text,
    label: "function",
    tab: TABS.contract,
  },
  {
    name: "FECHA ASIGNACION FUNCION",
    type: fieldTypes.text,
    label: "functionDate",
    tab: TABS.contract,
  },
  {
    name: "CATEGORIA",
    type: fieldTypes.text,
    label: "category",
    tab: TABS.contract,
  },
  {
    name: "ESPECIALIDAD",
    type: fieldTypes.text,
    label: "specialty",
    tab: TABS.contract,
  },
  {
    name: "CONTRATISTA",
    type: fieldTypes.text,
    label: "contratista",
    tab: TABS.contract,
  },
  {
    name: "TIPO DE CONTRATO",
    type: fieldTypes.text,
    label: "contractType",
    tab: TABS.contract,
  },
  {
    name: "FECHA DE INGRESO",
    type: fieldTypes.text,
    label: "incomeDate",
    tab: TABS.contract,
  },
  {
    name: "FECHA DE EGRESO",
    type: fieldTypes.text,
    label: "outcomeDate",
    tab: TABS.contract,
  },  
  {
    name: "TIPO DE JORNADA",
    type: fieldTypes.text,
    label: "jornadaType",
    tab: TABS.contract,
  },
  {
    name: "HORAS DIARIAS CONTRATO",
    type: fieldTypes.text,
    label: "hoursPerDay",
    tab: TABS.contract,
  },
  {
    name: "HORAS SEMANALES CONTRATO",
    type: fieldTypes.text,
    label: "weeklyHoursContract",
    tab: TABS.contract,
  },
  {
    name: "HORAS MENSUALES CONTRATO",
    type: fieldTypes.text,
    label: "hoursPerMonth",
    tab: TABS.contract,
  },
  {
    name: "LUGAR DE PAGO",
    type: fieldTypes.text,
    label: "paymentLocation",
    tab: TABS.location,
  },
  {
    name: "LUGAR DE TRABAJO",
    type: fieldTypes.text,
    label: "jobLocation",
    tab: TABS.location,
  },
  {
    name: "GERENCIA",
    type: fieldTypes.text,
    label: "management",
    tab: TABS.location,
  },
  {
    name: "DEPARTAMENTO",
    type: fieldTypes.text,
    label: "department",
    tab: TABS.location,
  },
  {
    name: "SECCION",
    type: fieldTypes.text,
    label: "section",
    tab: TABS.location,
  },
  {
    name: "FORMA DE PAGO",
    type: fieldTypes.text,
    label: "paymentMethod",
    tab: TABS.remuneration,
  },
  {
    name: "BANCO",
    type: fieldTypes.text,
    label: "bank",
    tab: TABS.remuneration,
  },
  {
    name: "CUENTA BANCARIA",
    type: fieldTypes.text,
    label: "bankAccount",
    tab: TABS.remuneration,
  },
  {
    name: "TIPO DE CUENTA BANCARIA",
    type: fieldTypes.text,
    label: "bankAccountType",
    tab: TABS.remuneration,
  },
  {
    name: "UNIDAD SALARIAL",
    type: fieldTypes.text,
    label: "salaryUnit",
    tab: TABS.remuneration,
  },
  {
    name: "MONEDA",
    type: fieldTypes.text,
    label: "coin",
    tab: TABS.remuneration,
  },
  {
    name: "SUELDO BASICO",
    type: fieldTypes.text,
    label: "salary",
    tab: TABS.remuneration,
  },
  {
    name: "SINDICATO",
    type: fieldTypes.text,
    label: "laborUnion",
    tab: TABS.remuneration,
  },
  {
    name: "JUBILADO",
    type: fieldTypes.text,
    label: "retired",
    tab: TABS.remuneration,
  },
  {
    name: "TURNO",
    type: fieldTypes.text,
    label: "shift",
    tab: TABS.time,
  },
  {
    name: "FECHA ASIGNACION TURNO",
    type: fieldTypes.text,
    label: "shiftDate",
    tab: TABS.time,
  },
];

export default NAME;
